import { Component, EventEmitter, forwardRef, Host, Input, OnInit, Optional, Output, SkipSelf } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FormComponentControl } from '../form-component-control';

@Component({
  selector: 'app-input-group-search',
  templateUrl: './input-group-search.component.html',
  styleUrls: ['./input-group-search.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputGroupSearchComponent),
      multi: true
    }
  ]
})
export class InputGroupSearchComponent extends FormComponentControl implements OnInit {
  @Input() inputGroupClass;
  @Input() id;
  @Output() onSearch: EventEmitter<string> = new EventEmitter();

  constructor(
    @Optional() @Host() @SkipSelf()
    private cc: ControlContainer
  ) { super(cc); }

  ngOnInit() {
    this.checkInitialControl();
  }

  search() {
    this.onSearch.emit(this.value);
  }

  clearSearch() {
    this.value = null;
    this.onSearch.emit(this.value);
  }
}
